module.exports = __webpack_public_path__ + "24e004ab/img/note-list-icon.961c1485.svg";